import { useMeleeContext } from 'draft/context/MeleeContextProvider';
import { DefaultDraftOptions, DraftOptions, GameType, StagePack } from 'draft/types';
import React, { useState, useEffect } from 'react'

import { Modal, Button, Icon, Image } from 'semantic-ui-react'
import meleeLogo from '../../assets/melee_logo.webp'
import ultimateLogo from '../../assets/ultimate_logo.svg'

interface Props {
    open: boolean,
    setOpen: (isOpen: boolean) => void;
}

const OptionsModal = ({ open, setOpen }: Props) => {
    const meleeContext = useMeleeContext();
    const [gameType, setGameType] = useState<GameType>(meleeContext ? meleeContext.draftOptions.gameType : GameType.Melee);
    const [memeStageChance, setMemeStageChance] = useState<number>(meleeContext ? meleeContext.draftOptions.memeStageChance : 20);
    const [stagePack, setStagePack] = useState<StagePack>(meleeContext ? meleeContext.draftOptions.stagePack : DefaultDraftOptions().stagePack);

    const saveAndClose = () => {
        var newDraftOptions: DraftOptions = {
            memeStageChance: memeStageChance,
            gameType: gameType,
            stagePack: stagePack,
            showTimer: false

        }
        meleeContext?.setDraftOptions(newDraftOptions);
        setOpen(false);
    }

    useEffect(() => {
        if (!meleeContext) return;
        // Initial values if loading in from refresh
        setGameType(meleeContext.draftOptions.gameType);
        setMemeStageChance(meleeContext.draftOptions.memeStageChance);
        setStagePack(meleeContext.draftOptions.stagePack);
    }, [meleeContext?.draftOptions]) // eslint-disable-line react-hooks/exhaustive-deps


    return (
        <Modal
            onClose={() => setOpen(false)}
            onOpen={() => setOpen(true)}
            open={open}
            className='melee-modal'
            style={{ maxWidth: '50em' }}
        >
            <Modal.Content>
                <h2>Options</h2>
                <div style={{ marginTop: 32 }}>
                    <h3>Game</h3>
                    <div className='radio-team-container'>
                        <button
                            className={`radio-team-button yellow ${gameType === GameType.Melee ? 'selected' : ''}`}
                            onClick={() => setGameType(GameType.Melee)}
                        >
                            <Image size="small" src={meleeLogo} />
                        </button>
                        <button
                            className={`radio-team-button yellow ${gameType === GameType.Ultimate ? 'selected' : ''}`}
                            onClick={() => setGameType(GameType.Ultimate)}
                        >
                            <Image size="small" style={{ filter: "invert(1)" }}
                                src={ultimateLogo} />
                        </button>
                    </div>

                    <div style={{textAlign: 'center'}}>
                        <p style={{marginBottom: 8}}>Meme-Stage draft percentage:</p>
                        <select
                            className='melee-dropdown'
                            value={memeStageChance}
                            onChange={(e: any) => setMemeStageChance(e.target.value)}
                            style={{margin:'auto'}}
                        >
                            <option value={50}>100% </option>
                            <option value={50}>75% </option>
                            <option value={50}>50% </option>
                            <option value={40}>40% </option>
                            <option value={30}>30% </option>
                            <option value={20}>20% (Standard)</option>
                            <option value={10}>10% </option>
                            <option value={5}>5%</option>
                            <option value={0}>0%</option>
                        </select>
                    </div>

                    {gameType === GameType.Melee && (
                        <div style={{textAlign: 'center', marginTop: 16}}>
                            <p style={{marginBottom: 8}}>Stage Pack:</p>
                            <select
                                className='melee-dropdown'
                                value={stagePack}
                                onChange={(e: any) => setStagePack(e.target.value as StagePack)}
                                style={{margin: 'auto'}}
                            >
                                <option value={StagePack.Standard}>Standard</option>
                                <option value={StagePack.StageMod}>Stage Mod</option>
                            </select>
                            {stagePack === StagePack.StageMod && (
                                <p style={{marginTop: 12, fontSize: '0.9em', maxWidth: '32em', margin: '12px auto 0'}}>
                                    Showcased in{' '}
                                    <a
                                        className='melee-inline-button'
                                        href='https://www.youtube.com/watch?v=uuIEcKOaFSM&t=45s'
                                        target='_blank'
                                        rel='noopener noreferrer'
                                    >
                                        this video
                                    </a>
                                    . Download the mod{' '}
                                    <a
                                        className='melee-inline-button'
                                        href='https://drive.google.com/drive/folders/1ufPVSHda5NSxVHKlGr14JrHO22M3Mtp0'
                                        target='_blank'
                                        rel='noopener noreferrer'
                                    >
                                        here
                                    </a>
                                    .
                                </p>
                            )}
                        </div>
                    )}

                </div>
                <div className='action'>
                    <Button
                        style={{ marginTop: 32 }}
                        basic color='yellow' inverted onClick={() => saveAndClose()}>
                        <Icon name='save' />
                        Save
                    </Button>
                </div>
            </Modal.Content>
        </Modal>
    )
}

export default OptionsModal;